'use es6';

export default {
  CERTIFICATION_OVERVIEW: 'https://academy.hubspot.com/certification-overview',
  CERTIFICATION: 'https://academy.hubspot.com/certification',
  FREE_TRIAL: 'https://offers.hubspot.com/free-trial',
  HUBSPOT_FREE: 'https://www.hubspot.com/products/get-started',
  HELP: 'https://help.hubspot.com/',
  REVIEW_GUIDELINES: 'https://legal.hubspot.com/review-guidelines',
  TERMS_OF_USE: 'https://legal.hubspot.com/directory-tou',
  USER_GUIDES: {
    GENERAL: 'https://academy.hubspot.com/user-guides',
    LANDING_PAGE: 'https://knowledge.hubspot.com/landing-page-user-guide-v2',
    BLOG: 'https://knowledge.hubspot.com/blog-user-guide-v2',
    EMAIL: 'https://knowledge.hubspot.com/email-user-guide-v2',
    WEBSITE: 'https://knowledge.hubspot.com/website-user-guide'
  }
};